<template>
    <div>
        <div class="row">
            <div id="splash-screen" class="splash-screen">
                <div
                    class="info-panel"
                    :style="{ backgroundImage: 'url(' + bgImageUrl + ')' }"
                    style="display: grid"
                >
                    <base-logo class="logo-position-left"></base-logo>
                    <div class="info-panel-body py-5 pl-5">
                        <p class="f-22">Included in the Starter plan:</p>
                        <ul>
                            <li>
                                <span class="icon-check_circle"></span>Full
                                integration (deep link, web and mobile)
                            </li>
                            <li>
                                <span class="icon-check_circle"></span>No credit
                                card required
                            </li>
                            <!-- <li>
                            <span class="icon-check_circle"></span>Personalized
                            theming and branding
                        </li>
                        <li>
                            <span class="icon-check_circle"></span>Hosted on
                            secure SOC 2 type 2 infrastructure
                        </li> -->
                        </ul>
                    </div>
                    <!-- <div
                    v-if="!$route.meta.noFooterBar == true"
                    class="contact-link text-center"
                >
                    Can’t access your account?
                    <router-link to="/contact-us">Contact us</router-link>
                </div> -->
                </div>
                <div class="color-overlay"></div>
            </div>
            <div class="col-md-6 col-xs-12 p-0">
                <div
                    class="info-panel"
                    :style="{ backgroundImage: 'url(' + bgImageUrl + ')' }"
                >
                    <base-logo class="logo-position-left"></base-logo>
                    <div class="info-panel-body py-5 pl-5">
                        <p class="f-22">Included in the Starter plan:</p>
                        <ul>
                            <!--<li>-->
                            <!--<span class="icon-check_circle"></span> 5 Free-->
                            <!--onboardings and verifications-->
                            <!--</li>-->
                            <li>
                                <span class="icon-check_circle"></span>Full
                                integration (deep link, web and mobile)
                            </li>
                            <li>
                                <span class="icon-check_circle"></span>No credit
                                card required
                            </li>
                            <!-- <li>
                            <span class="icon-check_circle"></span>Personalized
                            theming and branding
                        </li>
                        <li>
                            <span class="icon-check_circle"></span>Hosted on
                            secure SOC 2 type 2 infrastructure
                        </li> -->
                        </ul>
                    </div>
                    <!-- <div
                    v-if="!$route.meta.noFooterBar == true"
                    class="contact-link text-center"
                >
                    Can’t access your account?
                    <router-link to="/contact-us">Contact us</router-link>
                </div> -->
                </div>
                <div class="color-overlay"></div>
            </div>
            <div id="after-splash" class="col-md-6 p-0 bg-white after-splash">
                <base-logo
                    class="main-logo logo-style for-tablet-mobile"
                ></base-logo>
                <div class="login-panel custom-p-5">
                    <div class="">
                        <h2>Get Started</h2>
                        <p class="para">
                            For the purpose of industry regulation, your details
                            are required.
                        </p>
                        <div class="system-user-warning">
                            <i class="icon-error_outline"></i>
                        </div>
                        <div class="system-user-details">
                            <p>
                                We will send you an email to create your new
                                password.
                            </p>
                        </div>
                        <b-form
                            @submit.stop.prevent="onSubmit()"
                            @reset.stop.prevent="onHidden"
                        >
                            <div class="row custom-model-form">
                                <!-- <div class="col-md-12">
                                    <b-form-group
                                        id="input-group-1"
                                        label="User Name"
                                        label-for="user-name"
                                    >
                                        <b-form-input
                                            id="user-name"
                                            v-model="formData.username"
                                            v-validate="{
                                                required: true,
                                                max: 20,
                                                min: 6,
                                                regex: /^\S*$/,
                                                alpha_num: true,
                                            }"
                                            name="user name"
                                            type="text"
                                            :class="{
                                                'is-invalid':
                                                    errors.has('user name'),
                                            }"
                                            autocomplete="no"
                                        ></b-form-input>
                                    </b-form-group>
                                </div> -->
                                <div class="col-md-12 row-min-space">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group
                                                id="input-group-2"
                                                label="First Name"
                                                label-for="first-name"
                                            >
                                                <b-form-input
                                                    id="first-name"
                                                    v-model="formData.firstName"
                                                    v-validate="{
                                                        required: true,
                                                        max: 50,
                                                        alpha_spaces: true,
                                                    }"
                                                    placeholder="First Name"
                                                    name="first name"
                                                    type="text"
                                                    :readonly="uaePassObject.firstnameEN?true:false"
                                                    :class="{
                                                        'is-invalid':
                                                            errors.has(
                                                                'first name'
                                                            ),
                                                    }"
                                                    autocomplete="no"
                                                ></b-form-input>
                                            </b-form-group>
                                        </div>

                                        <div class="col-md-6">
                                            <b-form-group
                                                id="input-group-3"
                                                label="Last Name"
                                                label-for="last-name"
                                            >
                                                <b-form-input
                                                    id="last-name"
                                                    v-model="formData.lastName"
                                                    v-validate="{
                                                        required: true,
                                                        max: 50,
                                                        alpha_spaces: true,
                                                    }"
                                                    name="last name"
                                                    placeholder="Last Name"
                                                    :readonly="uaePassObject.lastnameEN?true:false"
                                                    :class="{
                                                        'is-invalid':
                                                            errors.has(
                                                                'last name'
                                                            ),
                                                    }"
                                                    autocomplete="no"
                                                ></b-form-input>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <b-form-group
                                        id="input-group-4"
                                        label="Email Address"
                                        label-for="email-address"
                                    >
                                        <b-form-input
                                            id="email-address"
                                            v-model="formData.email"
                                            v-validate="{
                                                required: true,
                                                email: true,
                                            }"
                                            name="email"
                                            placeholder="Email"
                                            :readonly="uaePassObject.email?true:false"
                                            :class="{
                                                'is-invalid':
                                                    errors.has('email'),
                                            }"
                                            autocomplete="no"
                                        ></b-form-input>
                                    </b-form-group>

                                    <!-- Company Name AND Phone Number Fields -->

                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group
                                                id="input-group-6"
                                                label="Company Name"
                                                label-for="company-name"
                                            >
                                                <b-form-input
                                                    id="company-name"
                                                    v-model="
                                                        formData.companyName
                                                    "
                                                    v-validate="{
                                                        required: true,
                                                    }"
                                                    name="company name"
                                                    placeholder="Company Name"
                                                    :class="{
                                                        'is-invalid':
                                                            errors.has(
                                                                'company name'
                                                            ),
                                                    }"
                                                    autocomplete="no"
                                                ></b-form-input>
                                            </b-form-group>
                                        </div>
                                        <!-- <phone-number
                                            :field="phoneNumberField"
                                            data-segment-id='5d43cc38a219146002fdd402'
                                        ></phone-number> -->
                                        <div class="col-md-6">
                                            <b-form-group
                                                id="input-group-7"
                                                label="Phone Number"
                                                label-for="phone-number"
                                            >
                                                <b-form-input
                                                    id="phone-number"
                                                    v-model="
                                                        formData.phoneNumber
                                                    "
                                                    v-validate="{
                                                        required: true,
                                                    }"
                                                    name="phone number"
                                                    :placeholder="phoneNumberPlaceholder"
                                                    :readonly="uaePassObject.mobile?true:false"
                                                    :class="{
                                                        'is-invalid':
                                                            errors.has(
                                                                'phone number'
                                                            ),
                                                    }"
                                                    autocomplete="no"
                                                ></b-form-input>
                                            </b-form-group>
                                        </div>
                                    </div>

                                    <!-- End Company Name AND Phone Number Fields -->

                                    <!-- <b-form-group
                                        v-if="
                                            nationality != 'Pakistan' &&
                                            nationalityTemp=='UAE'
                                        "
                                        id="input-group-5"
                                        label="Account Type"
                                        label-for="account-type"
                                    >
                                        <b-form-select
                                            v-model="formData.accountType"
                                            v-validate="{
                                                required: true,
                                            }"
                                            name="account type"
                                            :class="[
                                                'form-control',
                                                {
                                                    'is-invalid':
                                                        errors.has(
                                                            'account type'
                                                        ),
                                                },
                                            ]"
                                            :options="accountType"
                                        ></b-form-select>
                                    </b-form-group> -->

                                    <b-form-group
                                        id="input-group-5"
                                        label="Country"
                                        label-for="country"
                                        style="display: none"
                                    >
                                        <b-form-select
                                            v-model="formData.nationality"
                                            v-validate="{
                                                required: true,
                                            }"
                                            name="country"
                                            :class="[
                                                'form-control',
                                                {
                                                    'is-invalid':
                                                        errors.has('country'),
                                                },
                                            ]"
                                            :options="nationalities"
                                            disabled
                                        ></b-form-select>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="action-buttons">
                                <base-button
                                    :btn-label="buttonLabel"
                                    btn-type="submit"
                                    btn-variant="primary"
                                    class="width-100 blue-color"
                                    :class="loading ? 'disabled' : ''"
                                ></base-button>
                                <!-- <base-button
                                btn-label="Cancel   "
                                btn-type="reset"
                                :disabled="loading"
                                btn-variant="link"
                            ></base-button> -->
                            </div>
                            <div class="signup-links">
                                <div class="already-a-customer">
                                    <p>
                                        Already a customer?
                                        <a href="/">Login</a>
                                    </p>
                                </div>
                                <div class="already-a-customer">
                                    <p>
                                        <a
                                            v-if="
                                                formData.nationality ==
                                                'Pakistan'
                                            "
                                            href="https://www.idenfodirect.com/pk/book-a-demo"
                                            >Arrange A Demo</a
                                        >
                                        <a
                                            v-if="
                                                formData.nationality ==
                                                'Malaysia'
                                            "
                                            href="https://www.idenfodirect.com/book-a-demo"
                                            >Arrange A Demo</a
                                        >
                                    </p>
                                </div>
                            </div>
                            <base-toast></base-toast>
                        </b-form>
                    </div>
                    <b-modal
                        ref="termsandconditionpopup"
                        size="xl"
                        title="T&C And Privacy Policy"
                        hide-footer
                        :click-to-close="false"
                        :no-close-on-backdrop="true"
                        :no-close-on-esc="true"
                    >
                        <terms-and-condition-popup
                            @accepted="handleaccepted"
                        ></terms-and-condition-popup>
                    </b-modal>
                    <b-modal
                        ref="thankyoupopup"
                        size="sm"
                        title=""
                        hide-footer
                        :click-to-close="false"
                        :no-close-on-backdrop="true"
                        :no-close-on-esc="true"
                    >
                        <thank-you-popup
                            @thanked="handleThanked"
                        ></thank-you-popup>
                    </b-modal>
                </div>
                <base-footer></base-footer>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
//import Multiselect from 'vue-multiselect'
import _ from 'lodash'
//import resource from '@/api/resource'

import TermsAndConditionPopup from '@/components/popups/TermsAndConditionPopup.vue'
import ThankYouPopup from '@/components/popups/ThankYouPopup.vue'
import resource from '@/api/resource'
// import PhoneNumber from '@/components/registration/PhoneNumber.vue'

//const roleApi = new resource('access-control/roles')
//const dataSegmentApi = new resource('users/data-segments')
const viewBrandingApi = new resource('configurations/branding')

export default {
    components: {
        // Multiselect,
        TermsAndConditionPopup,
        ThankYouPopup,
        // PhoneNumber,
    },

    /*
|--------------------------------------------------------------------------
| Component > props
|--------------------------------------------------------------------------
*/
    props: {}, // End of Component > props
    /*
|--------------------------------------------------------------------------
| Component > data
|--------------------------------------------------------------------------
*/

    data() {
        return {
            nationality: process.env.VUE_APP_COUNTRY,
            nationalityTemp: process.env.VUE_APP_COUNTRY_TEMP,
            showSplashScreen: true,
            formData: this.initializeFormData(),
            dataSegments: [],
            selectedSegIds: [],
            cssProps: {
                backgroundImage: '',
            },
            bgImageUrl: '',
            companyType: [
                {
                    text: 'Financial',
                    value: 'financial',
                },
                {
                    text: 'Non Financial',
                    value: 'non-financial',
                },
            ],
            accountType: [
                {
                    text: 'Standard (Full features)',
                    value: 'standard',
                },
                {
                    text: 'Lite (Limited features - Please contact sales before selecting)',
                    value: 'lite',
                },
            ],

            // phoneNumberField: {
            //     isEmail: false,
            //     isNumeric: false,
            //     association: null,
            //     isRequired: true,
            //     isLocked: 'true',
            //     section: 'setup-profile',
            //     dataSegmentId: '60e412677eb4043d10ce5d2e',
            //     sectionTitle: 'Setup Profile',
            //     type: 'phone-number',
            //     sequenceNumber: 16,
            //     title: 'Phone Number',
            //     label: 'Phone Number',
            //     placeholder: 'Enter phone number',
            //     options: [],
            //     key: 'contactInfo.phoneNumber',
            //     status: 'active',
            //     isAlphaSpaces: false,
            // },
        }
    },
    /*
|--------------------------------------------------------------------------
| Component > computed
|--------------------------------------------------------------------------
*/
    computed: {
        ...mapGetters([
            'loading',
            'selectedItem',
            'hidePopup',
            'nationalities',
            'uaePassObject',
            'user','hasScopes'
        ]),

        title() {
            return this.selectedItem ? 'Modify System User' : 'Add System User'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update Account' : 'Create Account'
        },
        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },
        phoneNumberPlaceholder() {
            if (process.env.VUE_APP_COUNTRY_TEMP == 'PK') {
                return '+92-xxxxxxxxxx'
            } else if (process.env.VUE_APP_COUNTRY_TEMP == 'Qatar') {
                return '+974-xxxxxxxxx'
            }
            else if (process.env.VUE_APP_COUNTRY_TEMP == 'UK') {
                return '+44-xxxxxxxxxx'
            }
            else if (process.env.VUE_APP_COUNTRY_TEMP == 'UAE') {
                return '+971-xxxxxxxxx'
            }
        },
    }, // End of Component > computed
    /*
|--------------------------------------------------------------------------
| Component > watch
|--------------------------------------------------------------------------
*/
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */

        user(value) {
            // check if the value is not empty
            // and redirect to inner page
            if (value !== null && value !== undefined) {
                this.$store.commit('setDataSegmentId', value.dataSegmentIds[0])
                localStorage.setItem('dataSegmentId',value.dataSegmentIds[0])
                localStorage.setItem('activeDataSegmentId',value.dataSegmentIds[0])
                if (this.redirectUrl) {
                    this.$router.push({ path: this.redirectUrl })
                    this.$store.commit('setRedirectUrl', null)
                } else {
                    this.$router.push({ name: 'view-customer-profile' })
                    // if(this.hasScopes('view-customer-profile'))
                    // {
                    //     this.$router.push({ name: 'view-customer-profile' })
                    // }
                    // else
                    // {
                    //     this.$router.push({ name: 'view-temp-customer-profile' })
                    // }

                }
            }
        }, // End of user()


        selectedItem(value) {
            let self = this
            console.log(this)
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
                this.formData.id = value._id
                // let currentRole = _.find(this.roles, {
                //     value: this.formData.roleId,
                // })
                // if (!currentRole) {
                //     this.formData.roleId = null
                // }
                console.log(this.formData.dataSegmentIds)
                if (!this.formData.dataSegmentIds.length) {
                    self.selectedSegIds.push({
                        code: 'All',
                        id: 'all',
                    })
                } else {
                    this.formData.dataSegments.forEach(function (val) {
                        self.selectedSegIds.push({
                            code: val.name,
                            id: val._id,
                            title: val.title,
                        })
                    })
                }

                this.formData.profilePicture.fileName = value.avatar.fileName
                this.formData.profilePicture.originalName =
                    value.avatar.originalName
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
        selectedSegIds(val) {
            let allSelected = _.find(val, { id: 'all' })
            if (allSelected) {
                _.remove(val, function (n) {
                    return n.id != 'all'
                })
                this.dataSegments.forEach(function (ele) {
                    if (ele.id !== 'all') {
                        ele.$isDisabled = true
                    }
                })
            } else {
                this.dataSegments.forEach(function (ele) {
                    ele.$isDisabled = false
                })
            }
        },
        bgImageUrl() {
            //console.log('imageUrl changed!');
        },
    }, // End of Component > watch

    async mounted() {
        // get datasegment and roles options list
        this.getOptionsList()
        this.splashScreen()
        // console.log('-------mounted---------',this.uaePassObject)
        if(this.uaePassObject)
        {
            let tempFormData = {
                id: '',
                profilePicture: {
                    fileName: '',
                    originalName: '',
                },
                username: '',
                firstName: this.uaePassObject.firstnameEN,
                lastName: this.uaePassObject.lastnameEN,
                email: this.uaePassObject.email,
                companyName: '',
                phoneNumber: this.uaePassObject.mobile,
                // roleTitle: 'Admin',
                dataSegmentIds: [],
                companyType: 'financial',
                accountType: 'standard',
                nationality: process.env.VUE_APP_COUNTRY,
                nationalityTemp: process.env.VUE_APP_COUNTRY_TEMP,
                uaePassDetails: this.uaePassObject,
                ref: this.$route.query.ref,
            }
            this.formData = tempFormData
        }
        this.$gtm.trackView('Signup', '/signup')
    },
    async created() {
        // Change theme color
        await this.getBrandingData()
    }, // End of Component > watch
    methods: {
        splashScreen() {
            var splashScreen = document.getElementById('splash-screen')
            var afterSplash = document.getElementById('after-splash')
            // var timer = 5000
            setTimeout(function () {
                splashScreen.style.display = 'none'
                afterSplash.style.display = 'block'
            }, 3000)
        },
        initializeFormData() {
            return {
                id: '',
                profilePicture: {
                    fileName: '',
                    originalName: '',
                },
                username: '',
                firstName: '',
                lastName: '',
                email: '',
                companyName: '',
                phoneNumber: '',
                // roleTitle: 'Admin',
                dataSegmentIds: [],
                companyType: 'financial',
                accountType: 'standard',
                nationality: process.env.VUE_APP_COUNTRY,
                nationalityTemp: process.env.VUE_APP_COUNTRY_TEMP,
                ref: this.$route.query.ref,
            }
        },
        handleThanked() {
            this.$refs.thankyoupopup.hide()
        },
        async handleaccepted() {
            this.$refs.termsandconditionpopup.hide()
            try {
                this.formData.dataSegmentIds = _.map(this.selectedSegIds, 'id')
                if (this.formData.id) {
                    //update system user
                    await this.$store.dispatch(
                        'updateSystemUser',
                        this.formData
                    )
                } else {
                    //add system user

                    let dataSegment = await this.$store.dispatch(
                        'addDataSegment',
                        this.formData
                        //this.formData
                    )

                    if (dataSegment.data._id) {
                        this.formData.dataSegmentIds.push(dataSegment.data._id)
                        // console.log(this.formData)
                        let cust = await this.$store.dispatch(
                            'customerSignUp',
                            this.formData,
                            this.$route.query.ref
                        )
                        // console.log('api resp dataa----',cust.data)
                        if (cust.data.id) {
                            this.$refs.thankyoupopup.show()
                        }
                        else if (cust.data.accessToken) {
                            this.$store.commit('setToken', cust.data.accessToken)
                            this.$store.commit('setTokenExpiry', cust.data.expiresIn)
                            this.$store.commit('setUser', cust.data.profile)
                            this.$store.commit('setLoading', false)
                        }
                    } else {
                        console.log('DataSegment ID not found')
                    }
                }
            } catch (error) {
                console.log(error, 'There is an error on submit')
            }
        },
        async onSubmit() {
            this.gtmClick()
            this.$analytics.fbq.event('SignupClick')

            const result = await this.$validator.validateAll()
            if (result) {
                this.$refs.termsandconditionpopup.show()
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            Object.assign(this.formData, this.initializeFormData())
            this.selectedSegIds = []
            this.$validator.reset()
        }, // End of onHidden() method

        async getOptionsList() {
            //let self = this
            //data segments list
            // let dataSegmentList = await dataSegmentApi.list({
            //     status: 'active',
            //     ref: 'dropdown',
            //     perPage: 1000,
            // })
            // self.dataSegments = [{ code: 'All', id: 'all' }]
            // dataSegmentList.data.data.forEach(function(val) {
            //     self.dataSegments.push({
            //         code: val.code,
            //         id: val._id,
            //         title: val.title,
            //     })
            // })
            // Roles option list
            // let rolesList = await roleApi.list()
            // rolesList.data.data.forEach(function(val) {
            //     if (val.status !== 'archived') {
            //         self.roles.push({ text: val.title, value: val.id })
            //     }
            // })
        },
        async getBrandingData() {
            // this.lite
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
            if (data.data.bgImages) {
                this.bgImageUrl =
                    process.env.VUE_APP_FILE_SERVICE_URL +
                    'logo/' +
                    data.data.bgImages.signup.fileName
            } else {
                this.bgImageUrl = await this.bgImage()
            }
        }, // End of getBrandingData() method

        gtmClick() {
            this.$gtm.trackEvent({
                event: null, // Event type [default = 'interaction'] (Optional)
                category: 'default',
                action: 'Signup',
                label: 'New Sign Up',
                value: 1,
                noninteraction: false, // Optional
            })
        },
        async bgImage() {
            // if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
            //     return `url(${require('@/assets/images/Faisal_Masjid_Islamabad.jpg')})`
            // } else if (process.env.VUE_APP_COUNTRY == 'Malaysia') {
            //     return `url(${require('@/assets/images/image-banner.jpg')})`
            // } else if (process.env.VUE_APP_COUNTRY_TEMP == 'Oman'){
            //     return `url(${require('@/assets/images/oman_bg.jpg')})`
            // }
            // else {
            //     return `url(${require('@/assets/images/burj-khalifa.jpg')})`
            // }

            if (process.env.VUE_APP_COUNTRY == 'Pakistan') {
                return require('@/assets/images/Faisal_Masjid_Islamabad.jpg')
            } else if (process.env.VUE_APP_COUNTRY == 'Malaysia') {
                return require('@/assets/images/image-banner.jpg')
            } else if (process.env.VUE_APP_COUNTRY_TEMP == 'Oman') {
                return require('@/assets/images/oman_bg.jpg')
            } else {
                return require('@/assets/images/burj-khalifa.jpg')
            }
        },
    },
}
</script>
